import { parseCurrency } from '@helper/parseCurrency'

export const parseStorageKpiDataModal = (data: any[]): any[] => {
  const formattedValue = (value: number) => {
    return value.toFixed(2)
  }

  return data.map(item => {
    return {
      'data-data': item.data ? item.data : 0,
      'empresa-codigo-id': item.empresaId ? item.empresaId : '',
      'empresa-nome': item.empresaDescricao ? item.empresaDescricao : '',

      'cd-loja-codigo-id': item.lojaId ? item.lojaId : 0,
      'cd-loja-codigo-nome': item.lojaDescricao ? item.lojaDescricao : 0,

      'gerente-categoria-id': item.gerenteCategoriaDescricao
        ? item.gerenteCategoriaDescricao
        : '',
      'gerente-produto-id': item.gerenteProdutoDescricao
        ? item.gerenteProdutoDescricao
        : '',

      'produto-codigo-id': item.produtoId ? item.produtoId : 0,
      'produto-material-id': item.produtoDescricao ? item.produtoDescricao : '',
      'produto-status-id': item.statusDescricao ? item.statusDescricao : '',
      'produto-curva-abc-id': item.curvaABCDescricao
        ? item.curvaABCDescricao
        : '',

      'mundo-nome-id': item.mundoDescricao ? item.mundoDescricao : '',

      'categiria-compacta-nome-id': item.categoriaCompactaDescricao
        ? item.categoriaCompactaDescricao
        : '',

      'categiria-nome-id': item.categoriaDescricao
        ? item.categoriaDescricao
        : '',

      'fornecedor-codigo-id': item.fornecedorId ? item.fornecedorId : 0,
      'fornecedor-nome-id': item.fornecedorDescricao
        ? item.fornecedorDescricao
        : '',

      'valor-estoque-atual-id': item.estoqueReaisAtual
        ? item.estoqueReaisAtual
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-estoque-transito-id': item.estoqueReaisTransitoCompra
        ? item.estoqueReaisTransitoCompra
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-estoque-transito-trans-id': item.estoqueReaisTransitoTransferencia
        ? item.estoqueReaisTransitoTransferencia
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-estoque-reservado-id': item.estoqueReservaRS
        ? item.estoqueReservaRS
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-estoque-excesso-id': item.estoqueReaisReservado
        ? item.estoqueReaisReservado
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-estoque-deposito': item.estoqueReaisDeposito16
        ? item.estoqueReaisDeposito16
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-estoque-outros': item.estoqueReaisOutros
        ? item.estoqueReaisOutros
        : parseCurrency({ value: 0, country: 'pt-br' }),

      'valor-quantidade-atual-id': item.estoqueQuantidadeAtual
        ? item.estoqueQuantidadeAtual
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-quantidade-transito-id': item.estoqueQuantidadeTransitoCompra
        ? item.estoqueQuantidadeTransitoCompra
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-quantidade-transito-trans-id':
        item.estoqueQuantidadeTransitoTransferencia
          ? item.estoqueQuantidadeTransitoTransferencia
          : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-quantidade-reservado-id': item.estoqueQuantidadeReservado
        ? item.estoqueQuantidadeReservado
        : parseCurrency({ value: 0, country: 'pt-br' }),

      'valor-quantidade-dep16': item.estoqueQuantidadeDeposito16
        ? item.estoqueQuantidadeDeposito16
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'valor-quantidade-outros': item.estoqueQuantidadeOutros
        ? item.estoqueQuantidadeOutros
        : parseCurrency({ value: 0, country: 'pt-br' }),

      'dias-estoque-atual-id': item.estoqueDiasAtual
        ? item.estoqueDiasAtual
        : 0,
      'dias-estoque-transito-id': item.estoqueDiasTransitoCompra
        ? item.estoqueDiasTransitoCompra
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'dias-estoque-transito-trans-id': item.estoqueDiasTransitoTransferencia
        ? item.estoqueDiasTransitoTransferencia
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'dias-estoque-total': item.estoqueDiasTotal
        ? item.estoqueDiasTotal
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'dias-estoque-excesso-id': item.estoqueExcedidoDias
        ? item.estoqueExcedidoDias
        : 0,
      'dias-estoque-falta-id': item.estoqueEscassoDias
        ? item.estoqueEscassoDias
        : 0,

      'ruptura-num-sku-id': item.estoqueEscasso ? item.estoqueEscasso : 0,
      'ruptura-porcentagem-id': item.rupturaPercentual
        ? formattedValue(item.rupturaPercentual)
        : 0,

      'retabilidade-margem-id': item.margemRS
        ? item.margemRS
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'retabilidade-estoque-medio-id': item.estoqueMedio
        ? item.estoqueMedio
        : parseCurrency({ value: 0, country: 'pt-br' }),
      'retabilidade-gmroi-id': item.gmroi ? formattedValue(item.gmroi) : 0,
      'status-nome': item.statusDescricao,
      'curva-nome': item.curvaABCDescricao,
      'fornecedor-id': item.fornecedorId ? item.fornecedorId : '',
      'fornecedor-nome': item.fornecedorDescricao
        ? item.fornecedorDescricao
        : '',
      'vendas-cmv': item.vendaCMV4M ? item.vendaCMV4M : 0,
      'vendas-custo': item.custoUnitarioFatorConversao
        ? item.custoUnitarioFatorConversao
        : 0,
      'vendas-projetado': item.vendaCMVProjetado ? item.vendaCMVProjetado : 0,
      'sortimento-ruptura': item.sortimentoRuptura,
      'sortimento-posicao': item.sortimentoPosicao,
      'dcmv-real': item.cmvReal,
      'subcategoria-codigo-id': item.subCategoriaId ? item.subCategoriaId : 0,
      'subcategoria-nome-id': item.subCategoriaDescricao
        ? item.subCategoriaDescricao
        : ''
    }
  })
}
